import React from 'react';

import './index.css';

const Overlay = (props) => {
    return (
        <div className="overlay-container">
            <div className="overlay" onClick={props.onFormHide} />
            <div className="overlay-body">
                {props.children}
            </div>
        </div>
    );
}

export default Overlay;


// WEBPACK FOOTER //
// ./src/components/Overlay/index.js